import React, { useEffect, useState, useRef } from "react";
import ReactStars from "react-rating-stars-component";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import ProductCard from "../components/ProductCard";
import ReactImageZoom from "react-image-zoom";
import { TbGitCompare } from "react-icons/tb";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import watch from "../images/watch.jpg";
import Container from "../components/Container";
import { addToWishlist } from "../features/products/productSlilce";
import { useDispatch, useSelector } from "react-redux";
import {
  addRating,
  getAProduct,
  getAllProducts,
} from "../features/products/productSlilce";
import { toast } from "react-toastify";
import { addProdToCart, getUserCart, getuserProductWishlist, addToWishlistGuest } from "../features/user/userSlice";
import { 
  BsShare, 
  BsTruck, 
  BsArrowReturnLeft, 
  BsShieldCheck,
  BsStarFill,
  BsStar,
  BsStarHalf,
  BsGift,
  BsCheckCircle,
  BsCalendarEvent,
  BsChevronLeft,
  BsChevronRight,
  BsInstagram,
  BsWhatsapp
} from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { base_url } from "../utils/axiosConfig";
import axios from "axios";
import { trackViewContent, trackAddToCart, trackAddToWishlist } from "../utils/metaPixel";
// Import the dummy reviews and calculation function
import { dummyReviews, calculateAverageRating } from "../utils/dummyReviews";

const SingleProduct = () => {
  // Use the hook at the top level
  const { t, i18n } = useTranslation();
  
  const [quantity, setQuantity] = useState(1);
  const [alreadyAdded, setAlreadyAdded] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState('description');
  const [showStickyButtons, setShowStickyButtons] = useState(true); // Initially show sticky buttons on mobile from top of page
  const [translatedContent, setTranslatedContent] = useState({
    title: "",
    description: "",
    category: "",
    brand: "",
    price: 0,
    originalPrice: 0,
    discountedPrice: 0,
    tags: "",
    quantity: 0,
    isPreorder: false,
    preorderDeposit: 0,
    preorderReleaseDate: null,
    preorderNotes: "",
    images: [],
    oldPrice: 0,
    ratings: [],
    totalrating: 0
  });
  const [forceUpdate, setForceUpdate] = useState(0);
  const [reviewImages, setReviewImages] = useState([]); // Add this state for review images
  const [isImageModalOpen, setIsImageModalOpen] = useState(false); // State for image modal
  const [selectedReviewImage, setSelectedReviewImage] = useState(null); // State for selected review image
  const [selectedReview, setSelectedReview] = useState(null); // State for selected review
  const [reviewImageIndex, setReviewImageIndex] = useState(0); // State for review image index in modal
  const [showAllReviews, setShowAllReviews] = useState(false); // State for showing all reviews

  const location = useLocation();
  const navigate = useNavigate();
  const getProductId = location.pathname.split("/")[2];
  const dispatch = useDispatch();
  const productState = useSelector((state) => state?.product?.singleproduct);
  const productsState = useSelector((state) => state?.product?.product);
  const authCartState = useSelector((state) => state?.auth?.cartProducts);
  const guestCartState = useSelector((state) => state?.auth?.guestCart);
  const wishlistState = useSelector((state) => state?.auth?.wishlist?.wishlist);
  const rat = productState?.totalrating;
  const getTokenFromLocalStorage = localStorage.getItem("customer")
    ? JSON.parse(localStorage.getItem("customer"))
    : null;

  // Get current language from i18n
  const currentLanguage = i18n.language;

  // Check if user is authenticated by verifying token exists and is likely valid
  const isAuthenticated = () => {
    if (!getTokenFromLocalStorage || !getTokenFromLocalStorage.token) {
      return false;
    }
    // Additional check could be added here for token expiration
    return true;
  };

  // Get current cart items (either auth cart or guest cart)
  const getCurrentCartItems = () => {
    if (isAuthenticated()) {
      return authCartState;
    } else {
      return guestCartState;
    }
  };

  // Update translated content when productState or currentLanguage changes
  useEffect(() => {
    if (productState) {
      // Combine actual ratings with dummy reviews based on product name
      let combinedRatings = [...(productState?.ratings || [])];
      let combinedTotalRating = productState?.totalrating || 0;
      
      // Check if product name contains "Ganesha" or "Hanuman"
      const productName = productState?.translations?.[currentLanguage]?.title || productState?.title || "";
      
      if (productName.toLowerCase().includes("ganesha")) {
        // Add Ganesha dummy reviews
        combinedRatings = [...dummyReviews.ganesha, ...combinedRatings];
        combinedTotalRating = calculateAverageRating(combinedRatings);
      } else if (productName.toLowerCase().includes("hanuman")) {
        // Add Hanuman dummy reviews
        combinedRatings = [...dummyReviews.hanuman, ...combinedRatings];
        combinedTotalRating = calculateAverageRating(combinedRatings);
      }
      
      setTranslatedContent({
        title: productName,
        description: productState?.translations?.[currentLanguage]?.description || productState?.description || "",
        category: productState?.translations?.[currentLanguage]?.category || productState?.category || "",
        brand: productState?.translations?.[currentLanguage]?.brand || productState?.brand || "",
        price: productState?.price || 0,
        originalPrice: productState?.originalPrice || 0,
        discountedPrice: productState?.discountedPrice || 0,
        tags: productState?.tags || "",
        quantity: productState?.quantity || 0,
        isPreorder: productState?.isPreorder || false,
        preorderDeposit: productState?.preorderDeposit || 0,
        preorderReleaseDate: productState?.preorderReleaseDate || null,
        preorderNotes: productState?.preorderNotes || "",
        images: productState?.images || [],
        oldPrice: productState?.oldPrice || 0,
        ratings: combinedRatings,
        totalrating: combinedTotalRating
      });
    }
  }, [productState, currentLanguage, forceUpdate]);

  // Listen for language change events
  useEffect(() => {
    const handleLanguageChange = () => {
      setForceUpdate(prev => prev + 1);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  const config2 = {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage !== null ? getTokenFromLocalStorage.token : ""
      }`,
      Accept: "application/json",
    },
  };

  useEffect(() => {
    dispatch(getAProduct(getProductId));
    if (isAuthenticated()) {
      dispatch(getUserCart(config2));
    } else {
      dispatch(getUserCart()); // For guest users
    }
    dispatch(getAllProducts());
    // Fetch wishlist when component mounts
    if(getTokenFromLocalStorage!=null){
         dispatch(getuserProductWishlist());
    }
  }, []);

  // Track ViewContent when product data is loaded
  useEffect(() => {
    if (productState && productState._id) {
      trackViewContent({
        _id: productState._id,
        title: productState.title,
        price: productState.price,
        discountedPrice: productState.discountedPrice,
        category: productState.category,
      });
    }
  }, [productState]);

  useEffect(() => {
    // Check if product is already in cart
    const checkIfInCart = () => {
      const currentCart = getCurrentCartItems();
      
      if (isAuthenticated()) {
        // For authenticated users
        for (let index = 0; index < currentCart?.length; index++) {
          if (getProductId === currentCart[index]?.productId?._id) {
            setAlreadyAdded(true);
            return;
          }
        }
      } else {
        // For guest users
        for (let index = 0; index < currentCart?.length; index++) {
          if (getProductId === currentCart[index]?.productId) {
            setAlreadyAdded(true);
            return;
          }
        }
      }
      setAlreadyAdded(false);
    };
    
    checkIfInCart();
  }, [authCartState, guestCartState, getProductId]);

  // Sticky button logic for mobile - buttons appear from top, disappear when reaching original location,
  // reappear when scrolling further down
  useEffect(() => {
    const handleScroll = () => {
      const actionButtons = document.getElementById('action-buttons-desktop');
      if (actionButtons) {
        const rect = actionButtons.getBoundingClientRect();
        
        // Show sticky buttons when action buttons are NOT visible in viewport
        // Hide when action buttons are visible (user is near the original buttons)
        setShowStickyButtons(rect.bottom < 0 || rect.top > window.innerHeight);
      } else {
        // If element doesn't exist yet, show sticky buttons
        setShowStickyButtons(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const uploadCart = () => {
    dispatch(
      addProdToCart({
        productId: productState?._id,
        quantity,
        price: productState?.price,
        isPreorder: productState?.isPreorder || false,
        preorderDeposit: productState?.preorderDeposit || 0,
      })
    );
    
    // Track AddToCart event
    trackAddToCart(
      {
        _id: productState?._id,
        title: productState?.title,
        price: productState?.price,
        discountedPrice: productState?.discountedPrice,
        category: productState?.category,
      },
      quantity
    );
    
    // Refresh cart state
    setTimeout(() => {
      if (isAuthenticated()) {
        dispatch(getUserCart(config2));
      } else {
        dispatch(getUserCart()); // For guest users
      }
      navigate("/cart");
    }, 500);
  };

  // Function to handle instant checkout
  const handleInstantCheckout = () => {
    // Navigate to the instant checkout page with the product ID
    navigate(`/checkout/${getProductId}`);
  };

  const props = {
    width: 594,
    height: 600,
    zoomWidth: 600,
    img: productState?.images[selectedImage]?.url
      ? productState?.images[selectedImage]?.url
      : "https://images.pexels.com/photos/190819/pexels-photo-190819.jpeg?cs=srgb&dl=pexels-fernando-arcos-190819.jpg&fm=jpg",
  };

  const [orderedProduct, setorderedProduct] = useState(true);
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Product link copied to clipboard!");
    }).catch(() => {
      var textField = document.createElement("textarea");
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
      toast.success("Product link copied to clipboard!");
    });
  };

  const closeModal = () => {};
  const [popularProduct, setPopularProduct] = useState([]);

  useEffect(() => {
    let data = [];
    for (let index = 0; index < productsState?.length; index++) {
      const element = productsState[index];
      if (element.tags === "popular") {
        data.push(element);
      }
    }
    setPopularProduct(data);
  }, [productState, productsState]);

  const [star, setStar] = useState(null);
  const [comment, setComment] = useState(null);
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(0);
  const carouselRef = useRef(null);

  // Handle touch start for swipe detection
  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  // Handle touch move for swipe detection
  const handleTouchMove = (e) => {
    setEndX(e.touches[0].clientX);
  };

  // Handle touch end for swipe detection
  const handleTouchEnd = () => {
    if (!startX || !endX) return;
    
    const distance = startX - endX;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    
    if (isLeftSwipe) {
      // Swipe left - go to next image
      setSelectedImage(prev => (prev + 1) % translatedContent.images.length);
    } else if (isRightSwipe) {
      // Swipe right - go to previous image
      setSelectedImage(prev => (prev - 1 + translatedContent.images.length) % translatedContent.images.length);
    }
    
    // Reset touch positions
    setStartX(0);
    setEndX(0);
  };

  // Check for URL parameters to pre-fill rating (for email review links)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('orderId');
    
    // If there's an orderId in the URL, this is likely coming from an email review link
    if (orderId) {
      // Scroll to review section
      setTimeout(() => {
        const reviewSection = document.getElementById('review');
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: 'smooth' });
          // Add a visual indicator that this is from an email review request
          reviewSection.classList.add('bg-warning', 'bg-opacity-10', 'border', 'border-warning', 'rounded-3', 'p-3');
          
          // Add a message to the user
          const messageElement = document.createElement('div');
          messageElement.className = 'alert alert-warning mb-4';
          messageElement.innerHTML = `
            <div class='d-flex align-items-center'>
              <i class='bi bi-envelope me-2'></i>
              <div>
                <strong>Thank you for your purchase!</strong>
                <div>Please share your experience with this product.</div>
              </div>
            </div>
          `;
          reviewSection.insertBefore(messageElement, reviewSection.firstChild);
        }
      }, 1000);
    }
  }, []);
  
  // Check if product is in wishlist
  const isProductInWishlist = () => {
    // Check if user is logged in
    if (getTokenFromLocalStorage) {
      return wishlistState?.some((item) => item._id === getProductId);
    } else {
      // For guest users, check localStorage
      const guestWishlist = JSON.parse(localStorage.getItem("guestWishlist")) || [];
      return guestWishlist.includes(getProductId);
    }
  };

  const [isFilled, setIsFilled] = useState(isProductInWishlist());

  // Update isFilled state when wishlistState changes
  useEffect(() => {
    setIsFilled(isProductInWishlist());
  }, [wishlistState]);

  const handleWishlistToggle = async () => {
    try {
      // Check if user is logged in
      if (getTokenFromLocalStorage) {
        await dispatch(addToWishlist(getProductId)).unwrap();
        // Refresh wishlist after adding/removing
        dispatch(getuserProductWishlist());
        setIsFilled(!isFilled);
        
        // Track AddToWishlist event only when adding (not removing)
        if (!isFilled) {
          trackAddToWishlist({
            _id: productState?._id,
            title: productState?.title,
            price: productState?.price,
            discountedPrice: productState?.discountedPrice,
            category: productState?.category,
          });
        }
      } else {
        // For guest users, use guest wishlist functionality
        await dispatch(addToWishlistGuest(getProductId)).unwrap();
        setIsFilled(!isFilled);
        
        // Track AddToWishlist event only when adding (not removing)
        if (!isFilled) {
          trackAddToWishlist({
            _id: productState?._id,
            title: productState?.title,
            price: productState?.price,
            discountedPrice: productState?.discountedPrice,
            category: productState?.category,
          });
        }
      }
    } catch (error) {
      toast.error("Failed to update wishlist");
    }
  };

  const addRatingToProduct = async () => {
    if (star === null) {
      toast.error("Please add star rating");
      return false;
    } else if (comment === null) {
      toast.error("Please Write Review About the Product");
      return false;
    } else {
      try {
        // Upload images first if any
        let uploadedImages = [];
        if (reviewImages.length > 0) {
          const formData = new FormData();
          for (let i = 0; i < Math.min(reviewImages.length, 5); i++) {
            formData.append('images', reviewImages[i]);
          }
          
          const uploadResponse = await axios.post(
            `${base_url}upload/review-images`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getTokenFromLocalStorage?.token || ""}`
              }
            }
          );
          
          uploadedImages = uploadResponse.data;
        }
        
        // Submit review with images
        const result = await dispatch(
          addRating({ 
            star: star, 
            comment: comment, 
            prodId: getProductId,
            images: uploadedImages
          })
        );
        
        // Refresh product data immediately after rating submission
        if (result.meta.requestStatus === 'fulfilled') {
          // Dispatch getAProduct and wait for it to complete
          await dispatch(getAProduct(getProductId));
          // Force update the translated content
          setForceUpdate(prev => prev + 1);
        }
        
        // Clear form fields after successful submission
        setStar(null);
        setComment(null);
        setReviewImages([]);
        
        // Clear file input
        const fileInput = document.querySelector('.review-form input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }
      } catch (error) {
        console.error("Error submitting review:", error);
        toast.error("Failed to submit review. Please try again.");
      }
    }
    return false;
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Function to open image modal
  const openImageModal = () => {
    setIsImageModalOpen(true);
  };

  // Function to close image modal
  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  // Function to navigate to next image in modal
  const nextImage = () => {
    setSelectedImage(prev => (prev + 1) % translatedContent.images.length);
  };

  // Function to navigate to previous image in modal
  const prevImage = () => {
    setSelectedImage(prev => (prev - 1 + translatedContent.images.length) % translatedContent.images.length);
  };

  // Handle keyboard navigation in modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isImageModalOpen) return;
      
      if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isImageModalOpen]);

  // Function to open review image modal
  const openReviewImageModal = (review, imageIndex = 0) => {
    setSelectedReview(review);
    setSelectedReviewImage(review.images[imageIndex]);
    setReviewImageIndex(imageIndex);
    setIsImageModalOpen(true);
  };

  // Function to navigate to next review image in modal
  const nextReviewImage = () => {
    if (selectedReview && selectedReview.images.length > 0) {
      const nextIndex = (reviewImageIndex + 1) % selectedReview.images.length;
      setReviewImageIndex(nextIndex);
      setSelectedReviewImage(selectedReview.images[nextIndex]);
    }
  };

  // Function to navigate to previous review image in modal
  const prevReviewImage = () => {
    if (selectedReview && selectedReview.images.length > 0) {
      const prevIndex = (reviewImageIndex - 1 + selectedReview.images.length) % selectedReview.images.length;
      setReviewImageIndex(prevIndex);
      setSelectedReviewImage(selectedReview.images[prevIndex]);
    }
  };

  // Handle keyboard navigation for review images in modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isImageModalOpen || !selectedReview) return;
      
      if (e.key === 'ArrowRight') {
        nextReviewImage();
      } else if (e.key === 'ArrowLeft') {
        prevReviewImage();
      } else if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isImageModalOpen, selectedReview, reviewImageIndex]);

  if (!productState) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading product...</p>
      </div>
    );
  }

  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": translatedContent?.title,
    "image": translatedContent?.images?.map(img => img.url),
    "description": translatedContent?.description?.replace(/<[^>]*>/g, ''), // Strip HTML tags
    "brand": {
      "@type": "Brand",
      "name": translatedContent?.brand
    },
    "category": translatedContent?.category,
    "offers": {
      "@type": "Offer",
      "url": `https://vedamerchandise.com/product/${getProductId}`,
      "priceCurrency": "INR",
      "price": translatedContent?.price,
      "availability": translatedContent?.quantity > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "priceValidUntil": "2026-12-31"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": translatedContent?.totalrating || 0,
      "reviewCount": (translatedContent?.title?.toLowerCase().includes("ganesha") ? dummyReviews.ganesha.length + (productState?.ratings?.length || 0) : translatedContent?.title?.toLowerCase().includes("hanuman") ? dummyReviews.hanuman.length + (productState?.ratings?.length || 0) : translatedContent?.ratings?.length || 0)
    }
  };

  // Collect all review images
  const allReviewImages = translatedContent?.ratings?.flatMap(review => 
    review.images?.map((image, index) => ({ image, review, index })) || []
  ) || [];

  // Get reviews to display (first 3 or all if showAllReviews is true)
  const reviewsToShow = showAllReviews 
    ? translatedContent?.ratings 
    : translatedContent?.ratings?.slice(0, 3) || [];

  return (
    <>
      <Meta 
        title={`${translatedContent?.title} - VEDA Mythological Toys`}
        description={translatedContent?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Explore this educational mythological toy from VEDA."}
        keywords={`${translatedContent?.title}, ${translatedContent?.category}, ${translatedContent?.brand}, mythological toy, educational toy, VEDA`}
        author="VEDA Merchandise"
        ogTitle={`${translatedContent?.title} - VEDA Mythological Toys`}
        ogDescription={translatedContent?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Explore this educational mythological toy from VEDA."}
        ogImage={translatedContent?.images?.[0]?.url}
        ogUrl={`https://vedamerchandise.com/product/${getProductId}`}
        ogType="product"
        twitterCard="summary_large_image"
        twitterTitle={`${translatedContent?.title} - VEDA Mythological Toys`}
        twitterDescription={translatedContent?.description?.replace(/<[^>]*>/g, '').substring(0, 160) || "Explore this educational mythological toy from VEDA."}
        twitterImage={translatedContent?.images?.[0]?.url}
        robots="index, follow"
        canonicalUrl={`https://vedamerchandise.com/product/${getProductId}`}
        schemaMarkup={schemaMarkup}
      />
      {/* Product Details Section */}
      <Container class1="main-product-wrapper py-5">
        <div className="row g-4">
          {/* Product Images */}
          <div className="col-12 col-lg-6">
            <div className="product-images-section">
              {/* Main Image Carousel for Mobile */}
              <div className="d-lg-none mb-3">
                <div 
                  ref={carouselRef}
                  className="main-image-carousel position-relative rounded-4 overflow-hidden shadow-lg"
                  style={{ backgroundColor: '#f8f9fa' }}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                >
                  {/* Main Image Display with Touch Scrolling */}
                  <div 
                    className="main-image-container d-flex w-100"
                    style={{ 
                      transform: `translateX(-${selectedImage * 100}%)`,
                      transition: 'transform 0.3s ease-in-out'
                    }}
                  >
                    {translatedContent?.images?.map((item, index) => (
                      <div 
                        key={index}
                        className="main-image-slide flex-shrink-0 w-100"
                        style={{ height: '400px' }}
                      >
                        <img
                          src={item?.url}
                          className="w-100 h-100 object-fit-contain"
                          alt={`Product ${index + 1}`}
                          style={{ cursor: 'zoom-in' }}
                          onClick={openImageModal}
                        />
                      </div>
                    ))}
                  </div>
                  
                  {/* Badges */}
                  {translatedContent?.tags?.includes("sale") && (
                    <div className="position-absolute top-0 start-0 m-3">
                      <span className="badge bg-danger fs-6 px-3 py-2 rounded-pill shadow">
                        🔥 Sale
                      </span>
                    </div>
                  )}
                  {translatedContent?.tags?.includes("new") && (
                    <div className="position-absolute top-0 end-0 m-3">
                      <span className="badge bg-warning text-dark fs-6 px-3 py-2 rounded-pill shadow">
                        ✨ New
                      </span>
                    </div>
                  )}
                  {translatedContent?.isPreorder && (
                    <div className="position-absolute top-0 end-0 m-3" style={{ marginTop: '60px' }}>
                      <span className="badge bg-[#e91e63] fs-6 px-3 py-2 rounded-pill shadow">
                        🕒 Preorder
                      </span>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Main Image for Desktop */}
              <div className="d-none d-lg-block main-product-image mb-3">
                <div 
                  className="image-container position-relative rounded-4 overflow-hidden shadow-lg" 
                  style={{ backgroundColor: '#f8f9fa' }}
                  onClick={openImageModal}
                >
                  <div style={{ cursor: 'zoom-in' }}>
                    <ReactImageZoom {...props} />
                  </div>
                 
                  {/* Badges */}
                  {translatedContent?.tags?.includes("sale") && (
                    <div className="position-absolute top-0 start-0 m-3">
                      <span className="badge bg-danger fs-6 px-3 py-2 rounded-pill shadow">
                        🔥 Sale
                      </span>
                    </div>
                  )}
                  {translatedContent?.tags?.includes("new") && (
                    <div className="position-absolute top-0 end-0 m-3">
                      <span className="badge bg-warning text-dark fs-6 px-3 py-2 rounded-pill shadow">
                        ✨ New
                      </span>
                    </div>
                  )}
                  {translatedContent?.isPreorder && (
                    <div className="position-absolute top-0 end-0 m-3" style={{ marginTop: '60px' }}>
                      <span className="badge bg-[#e91e63] fs-6 px-3 py-2 rounded-pill shadow">
                        🕒 Preorder
                      </span>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Thumbnail Images with dedicated mobile carousel */}
              <div className="d-lg-none">
                <div 
                  className="thumbnail-carousel d-flex flex-nowrap w-100" 
                  style={{ 
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    WebkitOverflowScrolling: 'touch',
                    padding: '10px 0'
                  }}
                >
                  {translatedContent?.images?.map((item, index) => (
                    <div 
                      key={index}
                      className="thumbnail-item px-1 flex-shrink-0"
                      style={{ width: '25%' }}
                    >
                      <div 
                        className={`thumbnail-inner rounded-3 shadow-sm ${selectedImage === index ? 'border border-3 border-danger' : 'border border-2 border-light'}`}
                        onClick={() => setSelectedImage(index)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img 
                          src={item?.url} 
                          className="img-fluid rounded-3" 
                          alt={`Product ${index + 1}`}
                          style={{ 
                            width: '100%', 
                            height: '80px', 
                            objectFit: 'cover'
                          }} 
                        />
                      </div>
                    </div>
                  ))}
                </div>
                
                {/* Mobile Carousel Indicators */}
                <div className="d-flex justify-content-center mt-2">
                  <div className="d-flex gap-2">
                    {translatedContent?.images?.map((_, index) => (
                      <button
                        key={index}
                        className={`rounded-circle border-0 ${selectedImage === index ? 'bg-danger' : 'bg-secondary'}`}
                        style={{ width: '10px', height: '10px' }}
                        onClick={() => setSelectedImage(index)}
                        aria-label={`Go to image ${index + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Desktop Thumbnails */}
              <div className="d-none d-lg-block">
                <div 
                  className="thumbnail-images d-flex flex-wrap gap-2 py-2" 
                >
                  {translatedContent?.images?.map((item, index) => (
                    <div 
                      key={index}
                      className={`thumbnail-item ${selectedImage === index ? 'active' : ''}`}
                      onClick={() => setSelectedImage(index)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img 
                        src={item?.url} 
                        className="img-fluid rounded-3 shadow-sm" 
                        alt={`Product ${index + 1}`}
                        style={{ 
                          width: '80px', 
                          height: '80px', 
                          objectFit: 'cover',
                          border: selectedImage === index ? '3px solid #dc3545' : '2px solid #e9ecef',
                          transition: 'all 0.3s ease'
                        }} 
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Product Info */}
          <div className="col-12 col-lg-6">
            <div className="product-info-section">
              {/* Product Title & Rating */}
              <div className="product-header mb-4">
                <h1 className="product-title display-5 fw-bold mb-3" style={{ color: '#1a1a1a' }}>
                  {translatedContent?.title}
                </h1>
                <div className="product-rating d-flex align-items-center gap-3 mb-3 flex-wrap">
                  <div className="stars d-flex align-items-center">
                    <ReactStars
                      key={`product-rating-${translatedContent?.totalrating}`}
                      count={5}
                      size={22}
                      value={Number(translatedContent?.totalrating) || 0}
                      edit={false}
                      activeColor="#ffc107"
                    />
                    <span className="ms-2 text-muted fw-medium">
                      ({translatedContent?.title?.toLowerCase().includes("ganesha") ? 71 + (productState?.ratings?.length || 0) : translatedContent?.title?.toLowerCase().includes("hanuman") ? 63 + (productState?.ratings?.length || 0) : translatedContent?.ratings?.length || 0} Global Ratings)
                    </span>
                  </div>
                  <button 
                    className="btn btn-link text-danger text-decoration-none p-0 fw-semibold"
                    onClick={() => document.getElementById('review')?.scrollIntoView({ behavior: 'smooth' })}
                  >
                    Write a Review
                  </button>
                </div>
              </div>

              {/* Price Section with modern card design */}
              <div className="price-section mb-4 p-4 rounded-4 shadow-sm" style={{ background: 'linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%)' }}>
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  {/* Display discounted price and original price with discount percentage */}
                  {translatedContent?.discountedPrice && translatedContent?.originalPrice && translatedContent?.discountedPrice < translatedContent?.originalPrice ? (
                    <>
                      <h2 className="current-price text-danger mb-0 fw-bold display-6">
                        ₹{translatedContent?.discountedPrice?.toLocaleString()}
                      </h2>
                      <span className="old-price text-muted text-decoration-line-through fs-4">
                        ₹{translatedContent?.originalPrice?.toLocaleString()}
                      </span>
                      <span className="badge bg-danger fs-6 px-3 py-2 rounded-pill">
                        {Math.round(((translatedContent?.originalPrice - translatedContent?.discountedPrice) / translatedContent?.originalPrice) * 100)}% OFF
                      </span>
                    </>
                  ) : translatedContent?.price ? (
                    <h2 className="current-price text-danger mb-0 fw-bold display-6">
                      ₹{translatedContent?.price?.toLocaleString()}
                    </h2>
                  ) : (
                    <h2 className="current-price text-danger mb-0 fw-bold display-6">
                      ₹{translatedContent?.discountedPrice?.toLocaleString()}
                    </h2>
                  )}
                </div>
                <p className="text-muted mb-0 mt-2 small">Inclusive of all taxes</p>
                
                {/* Preorder Pricing Info */}
                {translatedContent?.isPreorder && translatedContent?.preorderDeposit > 0 && (
                  <div className="mt-3 p-3 bg-white rounded-3">
                    <div className="d-flex justify-content-between">
                      <span>Full Price:</span>
                      <span className="fw-bold">₹{translatedContent?.price?.toLocaleString()}</span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span>Preorder Deposit:</span>
                      <span className="fw-bold text-primary">₹{translatedContent?.preorderDeposit?.toLocaleString()}</span>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <span>Remaining Balance:</span>
                      <span className="fw-bold">
                        ₹{(translatedContent?.price - translatedContent?.preorderDeposit)?.toLocaleString()}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* Product Details with modern styling */}
              <div className="product-details mb-4 p-4 bg-light rounded-4">
                <div className="detail-item d-flex align-items-center py-3 border-bottom">
                  <span className="detail-label fw-bold me-3" style={{ minWidth: '100px', color: '#555' }}>Category:</span>
                  <span className="detail-value badge bg-danger-subtle text-danger px-3 py-2 rounded-pill">
                    {translatedContent?.category}
                  </span>
                </div>
                <div className="detail-item d-flex align-items-center py-3 border-bottom">
                  <span className="detail-label fw-bold me-3" style={{ minWidth: '100px', color: '#555' }}>Brand:</span>
                  <span className="detail-value">{translatedContent?.brand}</span>
                </div>
                <div className="detail-item d-flex align-items-center py-3 border-bottom">
                  <span className="detail-label fw-bold me-3" style={{ minWidth: '100px', color: '#555' }}>Tags:</span>
                  <div className="detail-value">
                    {Array.isArray(translatedContent?.tags) ? (
                      translatedContent.tags.map((tag, index) => (
                        <span key={index} className="badge bg-warning text-dark me-1 px-2 py-1 rounded-pill">{tag}</span>
                      ))
                    ) : (
                      <span className="badge bg-warning text-dark px-2 py-1 rounded-pill">{translatedContent?.tags}</span>
                    )}
                  </div>
                </div>
                
                {/* Preorder Information */}
                {translatedContent?.isPreorder && (
                  <div className="detail-item d-flex align-items-center py-3 border-bottom">
                    <span className="detail-label fw-bold me-3" style={{ minWidth: '100px', color: '#555' }}>
                      <BsCalendarEvent className="me-1" /> Preorder:
                    </span>
                    <div className="detail-value">
                      <span className="badge bg-[#e91e63] px-3 py-2 rounded-pill">
                        Available for Preorder
                      </span>
                      {translatedContent?.preorderReleaseDate && (
                        <div className="mt-2">
                          <small className="text-muted">
                            Expected Release: {formatDate(translatedContent?.preorderReleaseDate)}
                          </small>
                        </div>
                      )}
                      {translatedContent?.preorderNotes && (
                        <div className="mt-2">
                          <small className="text-muted">
                            {translatedContent?.preorderNotes}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                
                <div className="detail-item d-flex align-items-center py-3">
                  <span className="detail-label fw-bold me-3" style={{ minWidth: '100px', color: '#555' }}>Availability:</span>
                  <div className={`detail-value fw-semibold ${translatedContent?.quantity > 0 || translatedContent?.isPreorder ? 'text-success' : 'text-danger'}`}>
                    <BsCheckCircle className="me-1" />
                    {translatedContent?.isPreorder
                      ? "Available for Preorder" 
                      : translatedContent?.quantity > 0 
                        ? "In Stock" 
                        : "Out of Stock"}
                  </div>
                </div>
              </div>

              {/* Quantity Selection */}
              {!alreadyAdded && (
                <div className="quantity-selection mb-4">
                  <h6 className="fw-bold mb-3" style={{ color: '#555' }}>Quantity:</h6>
                  <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                    <div className="quantity-controls d-flex align-items-center border rounded-pill shadow-sm w-auto mx-auto mx-md-0" style={{ overflow: 'visible' }}>
                      <button 
                        className="btn btn-light px-3 py-2 border-0"
                        onClick={() => setQuantity(Math.max(1, quantity - 1))}
                        disabled={quantity <= 1}
                        style={{ borderRadius: '50px 0 0 50px', minWidth: '44px', height: '44px', fontSize: '1.3rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <span>-</span>
                      </button>
                      <input
                        type="number"
                        className="form-control text-center border-0 fw-bold"
                        style={{ width: '50px', height: '44px', WebkitAppearance: 'none', MozAppearance: 'textfield', appearance: 'textfield', textAlign: 'center', fontSize: '1.1rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        min={1}
                        max={10}
                        value={quantity}
                        onChange={(e) => setQuantity(Math.max(1, Math.min(10, parseInt(e.target.value) || 1)))}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <button 
                        className="btn btn-light px-3 py-2 border-0"
                        onClick={() => setQuantity(Math.min(10, quantity + 1))}
                        disabled={quantity >= 10}
                        style={{ borderRadius: '0 50px 50px 0', minWidth: '44px', height: '44px', fontSize: '1.3rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                      >
                        <span>+</span>
                      </button>
                    </div>
                    <span className="text-muted small align-self-center">Max: 10</span>
                  </div>
                </div>
              )}

              {/* Action Buttons - Desktop */}
              <div id="action-buttons-desktop" className="action-buttons mb-4">
                <div className="d-grid gap-3">
                  <button
                    className="btn btn-lg fw-bold shadow rounded-pill"
                    onClick={() => {
                      alreadyAdded ? navigate("/cart") : uploadCart();
                    }}
                    style={{ 
                      backgroundColor: '#e91e63',
                      border: 'none',
                      color: 'white',
                      padding: '16px 32px',
                      fontSize: '1.1rem',
                      letterSpacing: '0.5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }}
                    
                  >
                    <span>
                      {alreadyAdded 
                        ? "Go to Cart" 
                        : translatedContent?.isPreorder 
                          ? "Preorder Now" 
                          : "Add to Cart"}
                    </span>
                  </button>
                  
                  {/* Checkout Now Button */}
                  <button
                    className="btn btn-lg fw-bold shadow rounded-pill"
                    onClick={handleInstantCheckout}
                    disabled={translatedContent?.tags?.includes("comingsoon")}
                    style={{ 
                      backgroundColor: translatedContent?.tags?.includes("comingsoon") ? '#dc3545' : '#dc3545',
                      border: 'none',
                      color: 'white',
                      padding: '16px 32px',
                      fontSize: '1.1rem',
                      letterSpacing: '0.5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      opacity: translatedContent?.tags?.includes("comingsoon") ? 0.6 : 1,
                      cursor: translatedContent?.tags?.includes("comingsoon") ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <span>
                      {translatedContent?.isPreorder 
                        ? "Preorder Checkout" 
                        : translatedContent?.tags?.includes("comingsoon") 
                          ? "Coming Soon" 
                          : "Checkout Now"}
                    </span>
                  </button>
                  
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button 
                      className="btn fw-semibold shadow-sm rounded-pill"
                      onClick={handleWishlistToggle}
                      style={{
                        flex: 1,
                        borderWidth: '2px',
                        borderColor: '#dc3545',
                        borderStyle: 'solid',
                        backgroundColor: isFilled ? '#dc3545' : 'white',
                        color: isFilled ? 'white' : '#dc3545',
                        padding: '14px 24px',
                        fontSize: '0.95rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                    >
                      {isFilled ? (
                        <>
                          <AiFillHeart style={{ fontSize: '20px' }} />
                          <span className="d-none d-sm-inline">Wishlisted</span>
                        </>
                      ) : (
                        <>
                          <AiOutlineHeart style={{ fontSize: '20px' }} />
                          <span className="d-none d-sm-inline">Add to Wishlist</span>
                        </>
                      )}
                    </button>
                    <button 
                      className="btn shadow-sm rounded-pill"
                      onClick={() => copyToClipboard(window.location.href)}
                      title="Share Product"
                      style={{
                        borderWidth: '2px',
                        borderColor: '#6c757d',
                        borderStyle: 'solid',
                        backgroundColor: 'white',
                        color: '#6c757d',
                        padding: '14px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <BsShare style={{ fontSize: '18px' }} />
                    </button>
                  </div>
                </div>
                
                {/* Social Buttons for Instagram and WhatsApp - Desktop */}
                <div className="social-buttons-desktop mt-3" style={{ display: 'flex', gap: '8px', alignItems: 'stretch' }}>
                  <a 
                    href="https://www.instagram.com/vedaepictales?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn shadow rounded-3"
                    style={{ 
                      backgroundColor: 'white',
                      border: '2px solid #dc3545',
                      color: '#dc3545',
                      padding: '8px 16px',
                      fontSize: '0.8rem',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      textDecoration: 'none'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://www.instagram.com/vedaepictales?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==', '_blank', 'noopener,noreferrer');
                    }}
                  >
                    <BsInstagram style={{ fontSize: '16px' }} />
                    <span>Instagram handle</span>
                  </a>
                  
                  <a 
                    href="https://wa.me/9920310246" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn shadow rounded-3"
                    style={{ 
                      backgroundColor: 'white',
                      border: '2px solid #25D366',
                      color: '#25D366',
                      padding: '8px 16px',
                      fontSize: '0.8rem',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      textDecoration: 'none'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.open('https://wa.me/9920310246', '_blank', 'noopener,noreferrer');
                    }}
                  >
                    <BsWhatsapp style={{ fontSize: '16px' }} />
                    <span>Chat on WhatsApp</span>
                  </a>
                </div>
                
                {/* Preorder Notice */}
                {translatedContent?.isPreorder && (
                  <div className="mt-3 p-3 bg-yellow-600 bg-opacity-10 border rounded-3">
                    <small className="">
                      <BsCalendarEvent className="me-1" />
                      This is a preorder item. Payment will be processed in full when the product is released and in stock.
                    </small>
                  </div>
                )}
              </div>

              {/* Shipping Info with modern icons */}
              <div className="shipping-info p-4 rounded-4 shadow-sm" style={{ backgroundColor: '#fff8e1' }}>
                <div className="row g-3">
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="icon-wrapper p-2 bg-white rounded-circle">
                        <BsTruck className="text-danger" size={20} />
                      </div>
                      <small className="fw-semibold text-dark">Free Shipping</small>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="icon-wrapper p-2 bg-white rounded-circle">
                        <BsArrowReturnLeft className="text-danger" size={20} />
                      </div>
                      <small className="fw-semibold text-dark">Easy Returns</small>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="icon-wrapper p-2 bg-white rounded-circle">
                        <BsShieldCheck className="text-danger" size={20} />
                      </div>
                      <small className="fw-semibold text-dark">Secure Payment</small>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="d-flex align-items-center gap-2">
                      <div className="icon-wrapper p-2 bg-white rounded-circle">
                        <BsGift className="text-danger" size={20} />
                      </div>
                      <small className="fw-semibold text-dark">Gift Wrapping</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Sticky Mobile Buttons */}
      <div 
        className={`mobile-sticky-buttons d-md-none ${showStickyButtons ? 'show' : ''}`}
        style={{
          position: 'fixed',
          bottom: '0',
          left: '0',
          right: '0',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          padding: '12px',
          boxShadow: '0 -2px 20px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          transform: showStickyButtons ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform 0.3s ease-in-out',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        <div style={{ display: 'flex', gap: '8px', alignItems: 'stretch' }}>
          <button
            className="btn shadow rounded-pill"
            onClick={() => {
              alreadyAdded ? navigate("/cart") : uploadCart();
            }}
            style={{ 
              backgroundColor: '#e91e63',
              border: 'none',
              color: 'white',
              padding: '12px 16px',
              fontSize: '0.85rem',
              letterSpacing: '0.2px',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            <span>
              {alreadyAdded 
                ? "Go to Cart" 
                : translatedContent?.isPreorder 
                  ? "Preorder Now" 
                  : "Add to Cart"}
            </span>
          </button>
          {/* Checkout Now Button for Mobile */}
          <button
            className="btn shadow rounded-pill"
            onClick={handleInstantCheckout}
            disabled={translatedContent?.tags?.includes("comingsoon")}
            style={{ 
              backgroundColor: translatedContent?.tags?.includes("comingsoon") ? '#ccc' : '#dc3545',
              border: 'none',
              color: 'white',
              padding: '12px 16px',
              fontSize: '0.85rem',
              letterSpacing: '0.2px',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              opacity: translatedContent?.tags?.includes("comingsoon") ? 0.6 : 1,
              cursor: translatedContent?.tags?.includes("comingsoon") ? 'not-allowed' : 'pointer',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            <span>
              {translatedContent?.isPreorder 
                ? "Preorder Checkout" 
                : translatedContent?.tags?.includes("comingsoon") 
                  ? "Coming Soon" 
                  : "Checkout Now"}
            </span>
          </button>
          <button 
            className="btn shadow rounded-pill"
            onClick={handleWishlistToggle}
            style={{
              borderWidth: '2px',
              borderColor: '#dc3545',
              borderStyle: 'solid',
              backgroundColor: isFilled ? '#dc3545' : 'white',
              color: isFilled ? 'white' : '#dc3545',
              minWidth: '45px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isFilled ? <AiFillHeart style={{ fontSize: '18px' }} /> : <AiOutlineHeart style={{ fontSize: '18px' }} />}
          </button>
        </div>
        
        {/* Social Buttons for Instagram and WhatsApp */}
        <div className="social-buttons mt-2" style={{ display: 'flex', gap: '4px', alignItems: 'stretch' }}>
          <a 
            href="https://www.instagram.com/vedaepictales?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
            target="_blank"
            rel="noopener noreferrer"
            className="btn shadow rounded-3"
            style={{ 
              backgroundColor: 'white',
              border: '2px solid #dc3545',
              color: '#dc3545',
              padding: '6px 12px',
              fontSize: '0.7rem',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              textDecoration: 'none'
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open('https://www.instagram.com/vedaepictales?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==', '_blank', 'noopener,noreferrer');
            }}
          >
            <BsInstagram style={{ fontSize: '14px' }} />
            <span>Instagram Handle</span>
          </a>
          
          <a 
            href="https://wa.me/9920310246" 
            target="_blank"
            rel="noopener noreferrer"
            className="btn shadow rounded-3"
            style={{ 
              backgroundColor: 'white',
              border: '2px solid #25D366',
              color: '#25D366',
              padding: '6px 12px',
              fontSize: '0.7rem',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              textDecoration: 'none'
            }}
            onClick={(e) => {
              e.preventDefault();
              window.open('https://wa.me/9920310246', '_blank', 'noopener,noreferrer');
            }}
          >
            <BsWhatsapp style={{ fontSize: '14px' }} />
            <span>Chat on WhatsApp</span>
          </a>
        </div>
      </div>

      {/* Product Tabs Section */}
      <Container class1="product-tabs-wrapper py-5">
        <div className="row">
          <div className="col-12">
            <div className="product-tabs">
              <ul className="nav nav-pills justify-content-center gap-2 mb-4" id="productTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link rounded-pill px-4 py-2 fw-semibold ${activeTab === 'description' ? 'active' : ''}`}
                    onClick={() => setActiveTab('description')}
                    style={activeTab === 'description' ? {
                      backgroundColor: '#dc3545',
                      border: 'none'
                    } : {}}
                  >
                    Description
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link rounded-pill px-4 py-2 fw-semibold ${activeTab === 'reviews' ? 'active' : ''}`}
                    onClick={() => setActiveTab('reviews')}
                    style={activeTab === 'reviews' ? {
                      backgroundColor: '#dc3545',
                      border: 'none'
                    } : {}}
                  >
                    Reviews ({(translatedContent?.title?.toLowerCase().includes("ganesha") ? dummyReviews.ganesha.length + (productState?.ratings?.length || 0) : translatedContent?.title?.toLowerCase().includes("hanuman") ? dummyReviews.hanuman.length + (productState?.ratings?.length || 0) : translatedContent?.ratings?.length || 0)})
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link rounded-pill px-4 py-2 fw-semibold ${activeTab === 'shipping' ? 'active' : ''}`}
                    onClick={() => setActiveTab('shipping')}
                    style={activeTab === 'shipping' ? {
                      backgroundColor: '#dc3545',
                      border: 'none'
                    } : {}}
                  >
                    Shipping
                  </button>
                </li>
              </ul>
              
              <div className="tab-content mt-4" id="productTabsContent">
                {/* Description Tab */}
                <div className={`tab-pane fade ${activeTab === 'description' ? 'show active' : ''}`}>
                  <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm">
                    <h4 className="mb-4 fw-bold text-danger fredoka">Product Description</h4>
                    <div 
                      className="product-description"
                      style={{ lineHeight: '1.8', color: '#555' }}
                      dangerouslySetInnerHTML={{ __html: translatedContent?.description }}
                    />
                    
                    {/* Preorder Description */}
                    {translatedContent?.isPreorder && translatedContent?.preorderNotes && (
                      <div className="mt-4 p-3 bg-yellow-600 bg-opacity-10 border  rounded-3">
                        <h5 className="fw-bold fredoka">Preorder Information</h5>
                        <p className="mb-0">{translatedContent?.preorderNotes}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Reviews Tab */}
                <div className={`tab-pane fade ${activeTab === 'reviews' ? 'show active' : ''}`}>
                  <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm">
                    <div className="reviews-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 gap-3">
                      <div>
                        <h4 className="mb-3 fw-bold text-danger">Customer Review Images</h4>
                        <div className="d-flex align-items-center gap-2">
                          <ReactStars
                            key={`reviews-rating-${translatedContent?.totalrating}`}
                            count={5}
                            size={24}
                            value={Number(translatedContent?.totalrating) || 0}
                            edit={false}
                            activeColor="#ffc107"
                          />
                          <span className="text-muted fw-medium">
                            Based on {(translatedContent?.title?.toLowerCase().includes("ganesha") ? 71 + (productState?.ratings?.length || 0) : translatedContent?.title?.toLowerCase().includes("hanuman") ? 63 + (productState?.ratings?.length || 0) : translatedContent?.ratings?.length || 0)} Ratings
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Review Images Carousel */}
                    {allReviewImages.length > 0 && (
                      <div className="review-images-carousel mb-5">
                        <h5 className="mb-3 fw-bold fredoka">Review Images</h5>
                        <div className="position-relative">
                          <div 
                            className="d-flex overflow-x-auto gap-3 pb-3" 
                            style={{ 
                              scrollbarWidth: 'none',
                              msOverflowStyle: 'none',
                              WebkitOverflowScrolling: 'touch'
                            }}
                          >
                            {allReviewImages.map((item, index) => (
                              <div 
                                key={index} 
                                className="flex-shrink-0" 
                                style={{ width: '120px', height: '120px', cursor: 'pointer' }}
                                onClick={() => openReviewImageModal(item.review, item.index)}
                              >
                                <img 
                                  src={item.image?.url} 
                                  alt={`Review ${index + 1}`} 
                                  className="img-fluid rounded"
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      {/* Reviews List - Right Half on Desktop, Top on Mobile */}
                      <div className="col-md-6 order-md-2">
                        <div className="reviews-list">
                          <h5 className="mb-3 fw-bold fredoka">Customer Reviews</h5>
                          {reviewsToShow && reviewsToShow.length > 0 ? (
                            <div className="reviews-container" style={{ maxHeight: '500px', overflowY: 'auto', paddingRight: '10px' }}>
                              {reviewsToShow.map((item, index) => (
                                <div key={index} className="review-item p-4 border rounded-4 mb-3 shadow-sm">
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div className="d-flex align-items-center gap-3">
                                      <div className="user-avatar bg-danger rounded-circle d-flex align-items-center justify-content-center text-white fw-bold" style={{ width: '50px', height: '50px', fontSize: '20px' }}>
                                        {item?.postedby?.firstname?.charAt(0)?.toUpperCase() || 'U'}
                                      </div>
                                      <span className="fw-bold">{item?.postedby?.firstname ? `${item.postedby.firstname} ${item.postedby.lastname || ''}` : 'User'}</span>
                                    </div>
                                    <ReactStars
                                      key={`individual-rating-${index}-${item?.star}`}
                                      count={5}
                                      size={18}
                                      value={Number(item?.star) || 0}
                                      edit={false}
                                      activeColor="#ffc107"
                                    />
                                  </div>
                                  <p className="mb-3" style={{ color: '#555', lineHeight: '1.6' }}>{item?.comment}</p>
                                                      
                                  {/* Review Images */}
                                  {item?.images && item.images.length > 0 && (
                                    <div className="mt-3">
                                      <div className="d-flex flex-wrap gap-2">
                                        {item.images.map((image, imgIndex) => (
                                          <div 
                                            key={imgIndex} 
                                            className="position-relative" 
                                            style={{ width: '80px', height: '80px', cursor: 'pointer' }}
                                            onClick={() => openReviewImageModal(item, imgIndex)}
                                          >
                                            <img
                                              src={image?.url}
                                              alt={`Review ${index + 1} - Image ${imgIndex + 1}`}
                                              className="img-fluid rounded"
                                              style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                            />
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                                      
                                  {/* Review Date */}
                                  {item?.createdAt && (
                                    <div className="mt-2 text-muted small">
                                      Reviewed on {new Date(item.createdAt).toLocaleDateString()}
                                    </div>
                                  )}
                                </div>
                              ))}
                                                  
                              {/* View More Button */}
                              {!showAllReviews && translatedContent?.ratings?.length > 3 && (
                                <div className="text-center mt-4 m-5">
                                  <button 
                                    className="btn btn-outline-danger fw-bold rounded-pill px-4 py-2"
                                    onClick={() => setShowAllReviews(true)}
                                  >
                                    View All {translatedContent?.ratings?.length} Reviews
                                  </button>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className="text-center py-5 text-muted">
                              <BsStarFill size={48} className="text-warning mb-3" />
                              <p className="fs-5">No reviews yet. Be the first to review this product!</p>
                            </div>
                          )}
                        </div>
                      </div>
                                          
                      {/* Review Form - Left Half on Desktop, Bottom on Mobile */}
                      <div className="col-md-6 order-md-1">
                        <div id="review" className="review-form p-4 border rounded-4 mb-4" style={{ backgroundColor: '#fff8e1', height: '100%' }}>
                          <h5 className="mb-3 fw-bold fredoka">Write a Review</h5>
                          <div className="mb-3">
                            <label className="form-label fw-semibold">Rating:</label>
                            <ReactStars
                              count={5}
                              size={28}
                              value={star || 0}
                              edit={true}
                              activeColor="#ffc107"
                              onChange={(value) => setStar(value)}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label fw-semibold">Comment:</label>
                            <textarea
                              className="form-control rounded-3"
                              rows="4"
                              placeholder="Share your thoughts about this product..."
                              value={comment || ''}
                              onChange={(e) => setComment(e.target.value)}
                              style={{ border: '2px solid #e9ecef' }}
                            />
                          </div>
                                              
                          {/* Image Upload for Review */}
                          <div className="mb-3">
                            <label className="form-label fw-semibold">Photos (Optional):</label>
                            <input
                              type="file"
                              multiple
                              accept="image/*"
                              className="form-control"
                              onChange={(e) => {
                                const newFiles = e.target.files ? Array.from(e.target.files) : [];
                                // Limit to 5 files
                                const limitedFiles = newFiles.slice(0, 5);
                                // Update state with new files (don't replace existing ones)
                                setReviewImages(prevFiles => [...prevFiles, ...limitedFiles]);
                              }}
                            />
                            <div className="form-text">You can upload up to 5 photos ({reviewImages.length} selected)</div>
                                                
                            {/* Preview selected images */}
                            {reviewImages.length > 0 && (
                              <div className="mt-2 d-flex flex-wrap gap-2">
                                {reviewImages.map((file, index) => (
                                  <div key={index} className="position-relative" style={{ width: '60px', height: '60px' }}>
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt={`Preview ${index + 1}`}
                                      className="img-fluid rounded"
                                      style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                    />
                                    <button 
                                      type="button"
                                      className="btn btn-danger btn-sm position-absolute top-0 end-0 p-1" 
                                      style={{ minWidth: '20px', height: '20px', fontSize: '10px' }}
                                      onClick={() => {
                                        setReviewImages(prevFiles => prevFiles.filter((_, i) => i !== index));
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                                              
                          <button
                            onClick={addRatingToProduct}
                            className="btn btn-danger fw-bold rounded-pill px-4 shadow-sm"
                            disabled={!star || !comment}
                          >
                            Submit Review
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Shipping Tab */}
                <div className={`tab-pane fade ${activeTab === 'shipping' ? 'show active' : ''}`}>
                  <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm">
                    <h4 className="mb-4 fw-bold text-danger fredoka">Shipping & Returns</h4>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="shipping-info-card p-4 border rounded-4 h-100 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <BsTruck className="text-danger" size={28} />
                            <h6 className="fw-bold mb-0 fredoka">Shipping Information</h6>
                          </div>
                          <ul className="list-unstyled mb-0" style={{ lineHeight: '2' }}>
                            <li className="mb-2">✓ Free shipping on all orders</li>
                            <li className="mb-2">✓ Delivery within 5-10 business days</li>
                            <li className="mb-2">✓ Tracking number provided</li>
                            <li>✓ Nationwide delivery coverage</li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="returns-info-card p-4 border rounded-4 h-100 shadow-sm" style={{ backgroundColor: '#fff8e1' }}>
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <BsArrowReturnLeft className="text-danger" size={28} />
                            <h6 className="fw-bold mb-0 fredoka">Return Policy</h6>
                          </div>
                          <ul className="list-unstyled mb-0" style={{ lineHeight: '2' }}>
                            <li className="mb-2">✓ 30-day return policy</li>
                            <li className="mb-2">✓ Easy return process</li>
                            <li className="mb-2">✓ Full refund guarantee</li>
                            <li>✓ No questions asked returns</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    
                    {/* Preorder Shipping Notice */}
                    {translatedContent?.isPreorder && (
                      <div className="mt-4 p-3 bg-warning bg-opacity-10 border border-warning rounded-3">
                        <h5 className="fw-bold text-warning fredoka">Preorder Shipping Information</h5>
                        <p className="mb-0">
                          Preorder items will be shipped once they become available in stock. 
                          You will receive a notification when your order is being processed for shipment.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Image Modal for Desktop Zoom and Review Images */}
      {isImageModalOpen && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center z-3"
          style={{ zIndex: 9999 }}
          onClick={closeImageModal}
        >
          <div 
            className="position-relative bg-white rounded-4 overflow-hidden shadow-lg"
            style={{ maxWidth: '90vw', maxHeight: '90vh' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="position-absolute top-0 end-0 m-3 btn btn-danger rounded-circle p-2 shadow"
              onClick={closeImageModal}
              style={{ zIndex: 10 }}
              aria-label="Close image viewer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </button>
            
            {/* Navigation for Product Images */}
            {!selectedReview && (
              <>
                {/* Previous Button */}
                <button
                  className="position-absolute start-0 top-50 translate-middle-y m-3 btn btn-light rounded-circle p-2 shadow"
                  onClick={prevImage}
                  style={{ zIndex: 10 }}
                  aria-label="Previous image"
                >
                  <BsChevronLeft size={20} />
                </button>
                
                {/* Next Button */}
                <button
                  className="position-absolute end-0 top-50 translate-middle-y m-3 btn btn-light rounded-circle p-2 shadow"
                  onClick={nextImage}
                  style={{ zIndex: 10 }}
                  aria-label="Next image"
                >
                  <BsChevronRight size={20} />
                </button>
              </>
            )}
            
            {/* Navigation for Review Images */}
            {selectedReview && (
              <>
                {/* Previous Button */}
                <button
                  className="position-absolute start-0 top-50 translate-middle-y m-3 btn btn-light rounded-circle p-2 shadow"
                  onClick={prevReviewImage}
                  style={{ zIndex: 10 }}
                  aria-label="Previous image"
                >
                  <BsChevronLeft size={20} />
                </button>
                
                {/* Next Button */}
                <button
                  className="position-absolute end-0 top-50 translate-middle-y m-3 btn btn-light rounded-circle p-2 shadow"
                  onClick={nextReviewImage}
                  style={{ zIndex: 10 }}
                  aria-label="Next image"
                >
                  <BsChevronRight size={20} />
                </button>
              </>
            )}
            
            {/* Main Image */}
            <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh' }}>
              <img
                src={selectedReview ? selectedReviewImage?.url : translatedContent?.images[selectedImage]?.url}
                alt={selectedReview ? "Review image" : `Product ${selectedImage + 1}`}
                className="img-fluid mh-100 mw-100"
                style={{ objectFit: 'contain', maxHeight: '70vh' }}
              />
            </div>
            
            {/* Review Information (if showing a review image) */}
            {selectedReview && (
              <div className="p-3 bg-light">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center gap-2">
                    <div className="user-avatar bg-danger rounded-circle d-flex align-items-center justify-content-center text-white fw-bold" style={{ width: '30px', height: '30px', fontSize: '14px' }}>
                      {selectedReview?.postedby?.firstname?.charAt(0)?.toUpperCase() || 'U'}
                    </div>
                    <span className="fw-bold">{selectedReview?.postedby?.firstname ? `${selectedReview.postedby.firstname} ${selectedReview.postedby.lastname || ''}` : 'User'}</span>
                  </div>
                  <ReactStars
                    count={5}
                    size={16}
                    value={Number(selectedReview?.star) || 0}
                    edit={false}
                    activeColor="#ffc107"
                  />
                </div>
                <p className="mb-0 text-muted" style={{ fontSize: '14px' }}>{selectedReview?.comment}</p>
              </div>
            )}
            
            {/* Thumbnails (for product images) */}
            {!selectedReview && (
              <div className="p-3 bg-light">
                <div className="d-flex gap-2 overflow-auto py-2">
                  {translatedContent?.images?.map((item, index) => (
                    <div
                      key={index}
                      className={`thumbnail-item flex-shrink-0 ${selectedImage === index ? 'active' : ''}`}
                      onClick={() => setSelectedImage(index)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={item?.url}
                        className="img-fluid rounded-2"
                        alt={`Product ${index + 1}`}
                        style={{
                          width: '60px',
                          height: '60px',
                          objectFit: 'cover',
                          border: selectedImage === index ? '2px solid #dc3545' : '1px solid #ddd'
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Popular Products Section */}
      <Container class1="popular-wrapper py-5">
        <div className="row">
          <div className="col-12 text-center mb-5">
            <h3 className="display-6 fw-bold fredoka">
              <span className="bg-yellow-200 text-dark py-2 px-4 rounded-pill">
                You Might Also Like
              </span>
            </h3>
          </div>
        </div>
        <div className="row g-4">
          {popularProduct && popularProduct.length > 0 ? (
            popularProduct.map((product, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-3">
                <ProductCard data={[product]} />
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5 text-muted">
              <p className="fs-5">No popular products available at the moment.</p>
            </div>
          )}
        </div>
      </Container>

      {/* Add spacing at bottom for mobile sticky buttons */}
      <div className="d-md-none" style={{ height: '80px' }}></div>
    </>
  );
};

export default SingleProduct;